const API = {
  //patientEnrollment: "https://apply4hsf.testcbidata.com/healthcare-1/api/PatientEnrollment"
  //patientEnrollment: "https://apply4hsf.testcbidata.com/healthcare-2/api/PatientEnrollment"
  patientEnrollment: process.env.VUE_APP_API_SERVER,
  //patientEnrollment: "https://wkqv2hsfwb08.testcbidata.com/api/PatientEnrollment"
};
export default API;
